import React, { useEffect, useState } from "react";
import ModalComponent from "../../../common/ModalComponent";

const InputAgentModal = ({ id, name, showModal, setShowModal, data }) => {
    const [content, setContent] = useState('');

    useEffect(() => {
        if (data) {
            setContent(data);
        }
    }, [data])

    const renderInputModal = () => {
        return (
            <div className="d-flex gap-2 justify-content-between align-items-start">
                <code>
                    {JSON.stringify(content, null, 2)}
                </code>
            </div>
        )
    }

    const render = () => {
        return (
            <ModalComponent
                full
                title={name}
                show={showModal}
                handleClose={(e) => {
                    e.stopPropagation();
                    setShowModal(false);
                }}
            >
                <div className="d-flex flex-column gap-2">
                    {renderInputModal()}
                </div>

            </ModalComponent>
        )
    }
    return render();
}
export default InputAgentModal